
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.22.0
 * Query Engine version: 605197351a3c8bdd595af2d2a9bc3025bca48ea2
 */
Prisma.prismaVersion = {
  client: "5.22.0",
  engine: "605197351a3c8bdd595af2d2a9bc3025bca48ea2"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.AuctionScalarFieldEnum = {
  id: 'id',
  title: 'title',
  auctionType: 'auctionType',
  startDate: 'startDate',
  endDate: 'endDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  auctionState: 'auctionState'
};

exports.Prisma.AuctionSettingsScalarFieldEnum = {
  id: 'id',
  auctionId: 'auctionId',
  location: 'location',
  description: 'description',
  termsAndConditions: 'termsAndConditions',
  paymentTerms: 'paymentTerms',
  shippingInfo: 'shippingInfo',
  resultsPublished: 'resultsPublished',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BiddingScheduleScalarFieldEnum = {
  id: 'id',
  auctionId: 'auctionId'
};

exports.Prisma.BiddingScheduleRangeScalarFieldEnum = {
  id: 'id',
  rangeEnd: 'rangeEnd',
  increment: 'increment',
  biddingScheduleId: 'biddingScheduleId'
};

exports.Prisma.LotScalarFieldEnum = {
  id: 'id',
  title: 'title',
  description: 'description',
  startBid: 'startBid',
  catalogNumber: 'catalogNumber',
  inventoryNumber: 'inventoryNumber',
  endDate: 'endDate',
  appraisalMin: 'appraisalMin',
  appraisalMax: 'appraisalMax',
  category: 'category',
  additionalInfo: 'additionalInfo',
  winnerInstructions: 'winnerInstructions',
  consignorId: 'consignorId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDisabled: 'isDisabled',
  isValid: 'isValid',
  status: 'status',
  auctionId: 'auctionId'
};

exports.Prisma.BidScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  amount: 'amount',
  type: 'type',
  lotId: 'lotId',
  userId: 'userId',
  auctionId: 'auctionId',
  isAuto: 'isAuto',
  removed: 'removed'
};

exports.Prisma.HighestBidScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  amount: 'amount',
  version: 'version',
  bidId: 'bidId',
  lotId: 'lotId',
  userId: 'userId',
  isAuto: 'isAuto'
};

exports.Prisma.ImageScalarFieldEnum = {
  id: 'id',
  key: 'key',
  position: 'position',
  lotId: 'lotId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  lastName: 'lastName',
  email: 'email',
  emailVerified: 'emailVerified',
  hashedPassword: 'hashedPassword',
  verificationToken: 'verificationToken',
  phoneNumber: 'phoneNumber',
  stripeId: 'stripeId',
  firstLogin: 'firstLogin',
  role: 'role',
  image: 'image',
  flagged: 'flagged',
  profileComplete: 'profileComplete',
  bidderGroupId: 'bidderGroupId'
};

exports.Prisma.BidderGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  buyerPremium: 'buyerPremium',
  isDefault: 'isDefault'
};

exports.Prisma.AddressScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  country: 'country',
  region: 'region',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  postalCode: 'postalCode'
};

exports.Prisma.AdminScalarFieldEnum = {
  id: 'id',
  email: 'email'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.ConsignorScalarFieldEnum = {
  id: 'id',
  cocode: 'cocode',
  name: 'name',
  lastName: 'lastName',
  email: 'email',
  address: 'address',
  notes: 'notes',
  commissionRate: 'commissionRate',
  consignorGroupId: 'consignorGroupId'
};

exports.Prisma.ConsignorGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  isDefault: 'isDefault',
  minimumCommission: 'minimumCommission'
};

exports.Prisma.ConsignorGroupTierScalarFieldEnum = {
  id: 'id',
  tierRate: 'tierRate',
  tierRangeEnd: 'tierRangeEnd',
  consignorGroupId: 'consignorGroupId'
};

exports.Prisma.SubscriptionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  lotId: 'lotId',
  auctionId: 'auctionId'
};

exports.Prisma.PaymentSelectionScalarFieldEnum = {
  id: 'id',
  auctionId: 'auctionId',
  userId: 'userId',
  paymentMethodId: 'paymentMethodId',
  paymentType: 'paymentType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.OneTimeTokenScalarFieldEnum = {
  rawData: 'rawData',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.InvoiceScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  auctionId: 'auctionId',
  numberOfLots: 'numberOfLots',
  totalAmount: 'totalAmount',
  paymentMethod: 'paymentMethod',
  invoiceStatus: 'invoiceStatus',
  sent: 'sent',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  dueAt: 'dueAt'
};

exports.Prisma.ConsignorReportScalarFieldEnum = {
  id: 'id',
  auctionId: 'auctionId',
  consignorId: 'consignorId',
  type: 'type',
  numberOfLots: 'numberOfLots',
  sent: 'sent',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.OutbidEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  auctionId: 'auctionId',
  userId: 'userId',
  lotId: 'lotId',
  bidAmount: 'bidAmount'
};

exports.Prisma.CouponScalarFieldEnum = {
  id: 'id',
  code: 'code',
  dealId: 'dealId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt',
  type: 'type',
  value: 'value'
};

exports.Prisma.CouponRedemptionScalarFieldEnum = {
  id: 'id',
  couponId: 'couponId',
  userId: 'userId',
  auctionId: 'auctionId',
  occurredAt: 'occurredAt'
};

exports.Prisma.NotificationPreferenceScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  enabled: 'enabled'
};

exports.Prisma.NotificationLogScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  createdAt: 'createdAt',
  tag: 'tag'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.AuctionType = exports.$Enums.AuctionType = {
  ONLINE: 'ONLINE',
  IN_PERSON: 'IN_PERSON',
  HYBRID: 'HYBRID'
};

exports.AuctionState = exports.$Enums.AuctionState = {
  CREATING: 'CREATING',
  PREVIEW: 'PREVIEW',
  PAUSED: 'PAUSED',
  AUCTION: 'AUCTION',
  SOFT_CLOSING: 'SOFT_CLOSING',
  POST_AUCTION: 'POST_AUCTION',
  MANUALLY_ENDED: 'MANUALLY_ENDED',
  ARCHIVED: 'ARCHIVED'
};

exports.LotStatus = exports.$Enums.LotStatus = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
  INVALID: 'INVALID'
};

exports.BidType = exports.$Enums.BidType = {
  ABSENTEE: 'ABSENTEE',
  MAX: 'MAX',
  STANDARD: 'STANDARD'
};

exports.Role = exports.$Enums.Role = {
  BUYER: 'BUYER',
  ADMIN: 'ADMIN'
};

exports.PaymentType = exports.$Enums.PaymentType = {
  CASH: 'CASH',
  DEBIT: 'DEBIT',
  CREDIT: 'CREDIT',
  ETRANSFER: 'ETRANSFER',
  CHEQUE: 'CHEQUE'
};

exports.InvoiceStatus = exports.$Enums.InvoiceStatus = {
  UNCONFIRMED: 'UNCONFIRMED',
  UNPAID: 'UNPAID',
  PAID: 'PAID',
  OVERDUE: 'OVERDUE',
  ERROR: 'ERROR'
};

exports.ConsignorReportType = exports.$Enums.ConsignorReportType = {
  PRESALE: 'PRESALE',
  POSTSALE: 'POSTSALE',
  UNSOLD: 'UNSOLD'
};

exports.CouponType = exports.$Enums.CouponType = {
  PERCENTAGE: 'PERCENTAGE',
  DOLLAR_AMOUNT: 'DOLLAR_AMOUNT'
};

exports.NotificationType = exports.$Enums.NotificationType = {
  OUTBID: 'OUTBID'
};

exports.Prisma.ModelName = {
  Auction: 'Auction',
  AuctionSettings: 'AuctionSettings',
  BiddingSchedule: 'BiddingSchedule',
  BiddingScheduleRange: 'BiddingScheduleRange',
  Lot: 'Lot',
  Bid: 'Bid',
  HighestBid: 'HighestBid',
  Image: 'Image',
  Account: 'Account',
  Session: 'Session',
  User: 'User',
  BidderGroup: 'BidderGroup',
  Address: 'Address',
  Admin: 'Admin',
  VerificationToken: 'VerificationToken',
  Consignor: 'Consignor',
  ConsignorGroup: 'ConsignorGroup',
  ConsignorGroupTier: 'ConsignorGroupTier',
  Subscription: 'Subscription',
  PaymentSelection: 'PaymentSelection',
  OneTimeToken: 'OneTimeToken',
  Invoice: 'Invoice',
  ConsignorReport: 'ConsignorReport',
  OutbidEvent: 'OutbidEvent',
  Coupon: 'Coupon',
  CouponRedemption: 'CouponRedemption',
  NotificationPreference: 'NotificationPreference',
  NotificationLog: 'NotificationLog'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
